export default __webpack_public_path__ + "static/media/avatar_tiger7.38b34070.mp3";